import React, { useEffect, useLayoutEffect, useState } from "react";
import {
    BlockEven,
    BlockOdd,
    BlockPic,
    Blocks,
    BlockSub,
    BlockText,
    Container,
    Footer,
    FooterLeft,
    FooterRight,
    Functions,
    WelcomeFunction,
    WelcomeIphone,
    WelcomeScreen,
    WelcomeTitle,
    WelcomeWeb,
    Wrap,
} from "./styles";
import Modal from "#app/interface/modal/Modal";
import LicenceModal from "#app/components/MainPage/LicenceModal";
import PolicyModal from "#app/components/MainPage/PolicyModal";
import { Url } from "finhelper";
import moment from "moment";

import iphoneImage from "./images/iphone.png";
import webImage from "./images/web.png";
import winImage1 from "./images/bs-win-1.png";
import chatImage1 from "./images/bs-chat-1.png";
import winImage2 from "./images/bs-win-2.png";
import chatImage2 from "./images/bs-chat-2.png";
import winImage3 from "./images/bs-win-3.png";
import winImage4 from "./images/bs-win-4.png";
import winImage5 from "./images/bs-win-5.png";
import blackSwanLogo from "./images/blackswan-w.svg";

interface MainPageProps {
    handleTitle?: (title: string) => void;
}

const MainPage: React.FC<MainPageProps> = (props) => {
    const [linkTg, setLink] = useState(process.env.TELEGRAM_BOT_LINK ?? "");
    const [isScrolled, setScrolled] = useState(false);
    const [isLicenceModalOpen, setLicenceModalOpen] = useState(false);
    const [isPolicyModalOpen, setPolicyModalOpen] = useState(false);

    useLayoutEffect(() => {
        const handleScroll = () => {
            if (window.pageYOffset > 0) {
                setScrolled(true);
            } else if (window.pageYOffset === 0) {
                setScrolled(false);
            }
        };

        document.addEventListener("scroll", handleScroll);

        const url = Url.getCurrentUrl();

        if (url === "/agreement") {
            Modal.handleShow();
            setLicenceModalOpen(true);
        }
        if (url === "/policy") {
            Modal.handleShow();
            setPolicyModalOpen(true);
        }
    }, []);

    useEffect(() => {
        props.handleTitle?.("BlackSwan");
    }, [props.handleTitle]);

    return (
        <Container>
            <Wrap className="wrap">
                <WelcomeTitle className="welcome-title">
                    <h1>CRM для финансовых консультантов</h1>
                    <p>Сочетает работу с клиентом — личный кабинет и приложение</p>
                </WelcomeTitle>
                <WelcomeScreen className="welcome-screens">
                    <WelcomeIphone className="screen screen--iphone">
                        <img src={iphoneImage} alt="iPhone" />
                    </WelcomeIphone>
                    <WelcomeWeb className="screen screen--web">
                        <img src={webImage} alt="Web" />
                    </WelcomeWeb>
                </WelcomeScreen>
            </Wrap>
            <WelcomeFunction className="welcome-functions" id="functions">
                <Wrap className="wrap">
                    <div className="functions-left">
                        <h2>Какие функции доступны в&nbsp;Black Swan</h2>
                        <Functions className="functions">
                            <div>
                                <div className="function">Учет клиентов</div>
                                <div className="function">Оценка эффективности</div>
                                <div className="function">Оценка результатов</div>
                            </div>
                            <div>
                                <div className="function">Формирование договоров</div>
                                <div className="function">Риск-профилирование</div>
                                <div className="function">Анализ источников</div>
                            </div>
                        </Functions>
                    </div>
                </Wrap>
            </WelcomeFunction>
            <Blocks className="blocks" id="functions">
                <BlockOdd className="block block--odd">
                    <Wrap className="wrap">
                        <BlockText className="block-text">
                            <div className="block-text-inner">
                                <BlockSub>На старте</BlockSub>
                                <h2>Веди учёт дел</h2>
                                <ul>
                                    <li>Проведение презентаций</li>
                                    <li>Планирование звонков, встреч и консультаций</li>
                                    <li>Учет потенциальных и действующих клиентов</li>
                                </ul>
                            </div>
                        </BlockText>
                        <BlockPic className="block-pic">
                            <div className="block-pics block-pics-1">
                                <div className="window-img">
                                    <img src={winImage1} alt="Window 1" />
                                </div>
                                <div className="chat-img">
                                    <img src={chatImage1} alt="Chat 1" />
                                </div>
                            </div>
                        </BlockPic>
                    </Wrap>
                </BlockOdd>
                <BlockEven className="block block--even">
                    <Wrap className="wrap">
                        <BlockPic className="block-pic">
                            <div className="block-pics block-pics-2">
                                <div className="window-img">
                                    <img src={winImage2} alt="Window 2" />
                                </div>
                                <div className="chat-img">
                                    <img src={chatImage2} alt="Chat 2" />
                                </div>
                            </div>
                        </BlockPic>
                        <BlockText className="block-text">
                            <div className="block-text-inner">
                                <BlockSub>Система скоринга</BlockSub>
                                <h2>Оценка эффективности</h2>
                                <ul>
                                    <li>Статистика активных действий за день, неделю, месяц.</li>
                                    <li>
                                        Система скоринга оценит Вашу работу и компетенции, и даст
                                        полезные рекомендации по развитию слабых сторон.
                                    </li>
                                </ul>
                            </div>
                        </BlockText>
                    </Wrap>
                </BlockEven>
                <BlockOdd className="block block--odd">
                    <Wrap className="wrap">
                        <BlockText className="block-text">
                            <div className="block-text-inner">
                                <BlockSub>Профилирование</BlockSub>
                                <h2>Автоматизируй рутину</h2>
                                <p>
                                    Формирование договоров с автоматической загрузкой клиентских
                                    данных из готовых или своих шаблонов.
                                </p>
                                <p>
                                    Автоматическое риск-профилирование по шаблонам ведущих
                                    финансовых компаний или с помощью своей методики.
                                </p>
                            </div>
                        </BlockText>
                        <BlockPic className="block-pic">
                            <div className="block-pics block-pics-3">
                                <div className="window-img">
                                    <img src={winImage3} alt="Window 3" />
                                </div>
                            </div>
                        </BlockPic>
                    </Wrap>
                </BlockOdd>
                <BlockEven className="block block--even">
                    <Wrap className="wrap">
                        <BlockPic className="block-pic">
                            <div className="block-pics block-pics-4">
                                <div className="window-img">
                                    <img src={winImage4} alt="Window 4" />
                                </div>
                            </div>
                        </BlockPic>
                        <BlockText className="block-text">
                            <div className="block-text-inner">
                                <BlockSub>Маркетинговая модель</BlockSub>
                                <h2>Анализируй источники привлечения клиентов</h2>
                                <p>Воронка по всем каналам</p>
                                <ul>
                                    <li>Вебинар</li>
                                    <li>Мероприятия офлайн</li>
                                    <li>Звонки</li>
                                    <li>Социальные сети</li>
                                </ul>
                            </div>
                        </BlockText>
                    </Wrap>
                </BlockEven>
                <BlockOdd className="block block--odd">
                    <Wrap className="wrap">
                        <BlockText className="block-text">
                            <div className="block-text-inner">
                                <BlockSub className="block-sub">Индекс лояльности</BlockSub>
                                <h2>Оценивай результаты</h2>
                                <p>
                                    На основе анонимных отзывов клиентов и их оценке Вашей работы,
                                    система учета лояльности поможет правильно расставить приоритеты
                                    в работе.
                                </p>
                            </div>
                        </BlockText>
                        <BlockPic className="block-pic">
                            <div className="block-pics block-pics-5">
                                <div className="window-img">
                                    <img src={winImage5} alt="Window 5" />
                                </div>
                            </div>
                        </BlockPic>
                    </Wrap>
                </BlockOdd>
            </Blocks>
            <Footer className="footer">
                <Wrap className="wrap">
                    <FooterLeft className="footer-left">
                        <a href="http://blackswan.finance/#top">
                            <img src={blackSwanLogo} alt="Black Swan" />
                        </a>
                    </FooterLeft>
                    <FooterRight className="footer-right">
                        <div className="footer-email">
                            <a href="mailto:info@blackswan.finance">info@blackswan.finance</a>
                        </div>
                        <div className="footer-email">
                            <a href={linkTg} target="__blank">
                                Поддержка в Telegram
                            </a>
                        </div>
                        <div className="footer-phone">
                            <a href="tel:+79807056611">+7 980 705 66 11</a>
                        </div>
                    </FooterRight>
                </Wrap>
                <Wrap className="wrap">
                    <FooterLeft className="footer-left">
                        <div className="footer-copyright">
                            ООО «ДАТА ТЕКНОЛОДЖИС ЭНД АНАЛИТИКС КОНСАЛТИНГ»,{" "}
                            {moment().format("YYYY")}
                            <br />
                            ИНН: 7604323536,
                            <br />
                            ОГРН: 1177627011836
                            <br />
                            <div>
                                <a
                                    href="/agreement/"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        Modal.handleShow();
                                        setLicenceModalOpen(true);
                                    }}
                                >
                                    Лицензионное соглашение
                                </a>
                            </div>
                            <div>
                                <a
                                    target="_blank"
                                    rel="noreferrer"
                                    href="/policy/"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        Modal.handleShow();
                                        setPolicyModalOpen(true);
                                    }}
                                >
                                    Политика обработка данных
                                </a>
                            </div>
                        </div>
                    </FooterLeft>
                    <FooterRight className="footer-right" />
                </Wrap>
            </Footer>
            <LicenceModal
                show={isLicenceModalOpen}
                onClose={() => {
                    setLicenceModalOpen(false);
                }}
            />
            <PolicyModal
                show={isPolicyModalOpen}
                onClose={() => {
                    setPolicyModalOpen(false);
                }}
            />
        </Container>
    );
};

export default MainPage;
